import { z } from "zod/mini"

export const UIDContentType = "UIDContent" as const

export const UIDContentSchema = z.object({
	__TYPE__: z.literal(UIDContentType),
	value: z.string(),
})

export type UIDContent = z.infer<typeof UIDContentSchema>
